


















































import { defineComponent, ref, watch, watchEffect } from '@vue/composition-api';
import debounce from 'lodash/debounce';

import { notificationsMenu as active } from '../state';
import { useClient } from '@/use';
import { Notification } from '@/types';
import { getShowNotificationsOnStartup, setShowNotificationsOnStartup } from '@/utils/storage';

const headers = [
  { text: 'Time Created', value: 'created_at' },
  { text: 'Type', value: 'type' },
  { text: 'Text', value: 'text' },
];

export default defineComponent({
  name: 'NotificationsMenu',
  setup() {
    const loading = ref(false);
    const search = ref<string>('');
    const client = useClient();
    const notifications = ref<Notification[]>([]);
    const page = ref(1);
    const itemsPerPage = ref(10);
    const totalItems = ref(0);

    async function fetchNotifications() {
      loading.value = true;
      const paginated = await client.fetchNotifications(page.value, itemsPerPage.value, search.value);
      totalItems.value = paginated.total_number;
      notifications.value = paginated.notifications;
      loading.value = false;
    }

    function updateItemsPerPage(val: number) {
      if (val === -1) { return; }

      itemsPerPage.value = val;
      fetchNotifications();
    }

    function updatePage(val: number) {
      page.value = val;
      fetchNotifications();
    }

    // Fetch once opened
    watch(active, async (val) => {
      if (!val) { return; }

      fetchNotifications();
    });

    // Re-fetch anytime search is updated, debounced
    watch(search, debounce(fetchNotifications, 400));

    // Update startup preference if changed
    const startupPreference = ref(getShowNotificationsOnStartup());
    watchEffect(() => {
      setShowNotificationsOnStartup(startupPreference.value);
    });

    return {
      loading,
      search,
      active,
      headers,
      notifications,
      page,
      itemsPerPage,
      totalItems,
      fetchNotifications,
      updatePage,
      updateItemsPerPage,
      startupPreference,
    };
  },
});
